import { useMutation } from "./useApi";
import { approvalRequests, type AutoApproveToQuotaRequest } from "../api/approvalRequests.service";

export function useApprove() {
  return useMutation((id: string) => approvalRequests.approve(id));
}

export function useReject() {
  return useMutation((id: string) => approvalRequests.reject(id));
}

export function useSuspend() {
  return useMutation((id: string) => approvalRequests.suspend(id));
}

export function useReviewAgain() {
  return useMutation((id: string) => approvalRequests.reviewAgain(id));
}

export function useBulkApprove() {
  return useMutation((ids: string[]) => approvalRequests.bulkApprove(ids));
}

export function useBulkReject() {
  return useMutation((ids: string[]) => approvalRequests.bulkReject(ids));
}

export function useBulkSuspend() {
  return useMutation((ids: string[]) => approvalRequests.bulkSuspend(ids));
}

export function useAutoApproveToQuota() {
  return useMutation((body: AutoApproveToQuotaRequest) =>
    approvalRequests.autoApproveToQuota(body),
  );
}
